import { PermissionKey } from '@evimo/types/enums/permission-key';
import { AuthGuard } from '~/app/auth/guard/AuthGuard';
import { useDiagnosticRulesPage } from './hooks/useDiagnosticRulesPage';
import { DiagnosticRulesPageView } from './DiagnosticRulesPageView';

function DiagnosticRulesPageContent() {
  const page = useDiagnosticRulesPage();
  return <DiagnosticRulesPageView {...page} />;
}

export function DiagnosticRulesPageContainer() {
  return (
    <AuthGuard requiredPermissions={[PermissionKey.DIAGNOSTIC_RULES_READ]}>
      <DiagnosticRulesPageContent />
    </AuthGuard>
  );
}
